export function SeparatorQuickmenu() {
  return <span className="bg-foreground h-6 w-px" />
}
